<template>
    <div>
        <CheckboxInline name="agreement" :value="agree" @input="handleChange" :class="labelClass">
            Я прочитал и принимаю
            <a href="#" :class="linkClass">Публичную оферту</a> и
            <a href="#" :class="linkClass">
                Политику конфиденциальности
            </a> сервиса&nbsp;Your&nbsp;Loy.
        </CheckboxInline>
    </div>
</template>

<script>
import CheckboxInline from '@/components/form/CheckboxInline.vue';

export default {
  components: { CheckboxInline },

  model: {
    prop: 'agree',
    event: 'change',
  },

  props: {
    agree: Boolean,
    labelClass: String,
    linkClass: String,
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
